import { useNavigate } from "@/lib/router-compat";
import { Star } from "lucide-react";
import { useRewardBalance } from "@/hooks/useRewardBalance";

/**
 * Approach XP chip — engagement currency, not redeemable.
 * Drives level, badges, leaderboard, VIP threshold.
 */
const XpChip = () => {
  const navigate = useNavigate();
  const { totalPoints, loading } = useRewardBalance();

  if (loading || totalPoints === 0) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/hero-rewards#xp")}
      className="hidden sm:flex items-center gap-1.5 text-sm cursor-pointer hover:opacity-80 transition-opacity"
      aria-label={`Approach XP: ${totalPoints}`}
    >
      <Star size={16} className="text-accent" />
      <span className="font-semibold text-foreground">{totalPoints} XP</span>
    </button>
  );
};

export default XpChip;